import { rxStep1Icon, rxStep2Icon, rxStep3Icon, rxStep4Icon } from '../../components/assets';
import { VisualizationBoxItem } from '../../components/molecules/VisualizationBox/VisualizationBox';

export const VisualizationBoxItems: VisualizationBoxItem[] = [
  {
    icon: rxStep1Icon,
    title: 'Indikation und Arztpraxis wählen',
    text:
      'Wählen Sie Ihre Beschwerde aus der oben aufgeführten Liste oder durch die Schnellauswahl der meist gesuchten Indikationen. Wählen Sie Ihre Online Arztpraxis und klicken auf „Jetzt Online Rezept anfragen“ - Sie werden an die Website unserers Partners weitergeleitet.'
  },
  {
    icon: rxStep2Icon,
    title: 'Medizinischen Fragebogen ausfüllen',
    text: 'Beantworten Sie einen kurzen medizinischen Fragebogen und wählen Sie Ihr bevorzugtes Medikament.'
  },
  {
    icon: rxStep3Icon,
    title: 'Fragebogen wird verifiziert und ausgestellt',
    text:
      'Erfahrene Ärzte prüfen Ihren Fragebogen und stellen bei Eignung ein Privatrezept aus. Auf Ihren Wunsch kann Ihr Rezept an uns übermittelt werden.'
  },
  {
    icon: rxStep4Icon,
    title: 'Versandoption wählen',
    text:
      'Wählen Sie SHOP APOTHEKE als Versandoption, liefern wir Ihr Medikament innerhalb von 1-2 Werktagen versandkostenfrei  nach Hause. Sie müssen nichts weiter machen.'
  }
];
